(ns frontend.view.components.timeline.db
  (:require [frontend.db :as db]
            [reagent.core :as r]))

(defonce state (r/cursor db/app-state [:views :timeline]))
(defonce comment-state (r/cursor db/app-state [:views :timeline :comment]))
(defonce filters-state (r/cursor db/app-state [:views :timeline :filters]))
(defonce phone-state (r/cursor db/app-state [:views :timeline :phone]))
(defonce meeting-state (r/cursor db/app-state [:views :timeline :meeting]))

(defonce timeline-comment-length 5000)
(defonce default-entries-count 20)
